import React from 'react';

import { Table } from 'react-bootstrap';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line react/prop-types
const ActivitiesPreview = ({ activities }) => {
  const renderTbody = () => (
    <tbody>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {activities?.map(item => (
        <tr key={item.id}>
          <td>{item.productSlug}</td>
          <td>{item.title}</td>
          <td>{item.description}</td>
          <td>{item.address}</td>
          <td>{item.tags}</td>
          <td>{item.popularity}</td>
          <td>{item.city}</td>
          <td>{item.hours}</td>
          <td>{item.cancellationPolicy}</td>
          <td>{item.bachTip}</td>
          <td>{item.bookable}</td>
          <td>{item.featured}</td>
          <td>{item.bachified}</td>
          <td>{item.vendorId}</td>
          <td>{item.faqContent}</td>
          <td>{item.commission}</td>
          <td>{item.category}</td>
          <td>{item.subCategory}</td>
          <td>{item.vendorDisplayName}</td>
        </tr>
      ))}
    </tbody>
  );

  return (
    <>
      {/* TODO: Fix this the next time the file is edited. */}
      {/* eslint-disable-next-line react/prop-types */}
      {activities && activities.length ? (
        <div className='table-responsive'>
          <Table>
            <thead>
              <tr>
                <th>Product Slug</th>
                <th className={'table-cell__lg'}>Name</th>
                <th className={'table-cell__lg'}>Description</th>
                <th>Address</th>
                <th>Tags</th>
                <th>Popularity</th>
                <th>City</th>
                <th>Hours</th>
                <th className={'table-cell__lg'}>Cancellation Policy</th>
                <th>Bach Tip</th>
                <th>Bookable</th>
                <th>Featured</th>
                <th>Bachified</th>
                <th className={'table-cell__xlg'}>Vendor Id</th>
                <th>FAQ Content</th>
                <th>Commission</th>
                <th>Category</th>
                <th>Sub Category</th>
                <th className={'table-cell__lg'}>Vendor Display Name</th>
              </tr>
            </thead>
            {renderTbody()}
          </Table>
        </div>
      ) : (
        <p>No data</p>
      )}
    </>
  );
};

export default React.memo(ActivitiesPreview);
